export const skillSet = [
  {
    img: "",
    name: "JavaScript",
    description: "",
  },
  {
    img: "",
    name: "TypeScript",
    description: "",
  },
  {
    img: "",
    name: "ReactJs",
    description: "",
  },
  {
    img: "",
    name: "Material UI",
    description: "",
  },
  {
    img: "",
    name: "Bootstrap",
    description: "",
  },
  {
    img: "",
    name: "Tailwind",
    description: "",
  },
  {
    img: "",
    name: "AntDesign",
    description: "",
  },
  {
    img: "",
    name: "NextJs",
    description: "",
  },
  {
    img: "",
    name: "NestJs",
    description: "",
  },
  {
    img: "",
    name: "MongoDb",
    description: "",
  },
];
